import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29cc4d81&scoped=true&"
import script from "./userCoupon.js?vue&type=script&lang=js&"
export * from "./userCoupon.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=29cc4d81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cc4d81",
  null
  
)

export default component.exports